import { useContext } from 'react';
import { NotificationPermissionContext } from '@/contexts/notification-permission-context';

export function useNotificationPermission() {
  const context = useContext(NotificationPermissionContext);
  if (!context) {
    throw new Error('useNotificationPermission must be used within NotificationPermissionProvider');
  }
  return context;
}
